import initBookingOverlays from './events/booking-overlays.js';
import initEventHero from './events/event-hero.js';

const bookingToggles = document.querySelectorAll('.js-booking-toggle');

const hero = document.querySelectorAll('.js-event-hero');

if (bookingToggles && bookingToggles.length > 0) {
    initBookingOverlays(bookingToggles);
}

if (hero && hero.length > 0) {
    initEventHero(hero);
}
